import {
	REQUEST_STANDARD_LAYOUTS,
	RECEIVE_STANDARD_LAYOUTS,
	RECEIVE_STANDARD_LAYOUTS_ERROR,
} from "../actions/templateLayoutActions";

import {
	RECEIVE_UPDATE_LAYOUT,
	REQUEST_UPDATE_LAYOUT,
	UPDATE_LAYOUT_ERROR,
	REQUEST_ADD_LAYOUT,
	RECEIVE_ADD_LAYOUT,
	ADD_LAYOUT_ERROR,
	REQUEST_DELETE_LAYOUT,
	RECEIVE_DELETE_LAYOUT,
	DELETE_LAYOUT_ERROR,
} from "../actions/layoutActionsRedux";

const templateLayoutState = {
	isFetching: false,
	items: [],
	error: null,
	updated: false,
};

export const templateLayoutsReducer = (state = templateLayoutState, action) => {
	switch (action.type) {
		case REQUEST_STANDARD_LAYOUTS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null, updated: false };
		case RECEIVE_STANDARD_LAYOUTS:
			//sets new state and fetching ended
			action.payload;
			return { ...state, items: action.payload, isFetching: false };
		case RECEIVE_STANDARD_LAYOUTS_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case RECEIVE_ADD_LAYOUT:
			if (action.payload.templateLayout) {
				return { ...state, items: [...state.items, action.payload] };
			}
			return state;
		case RECEIVE_DELETE_LAYOUT:
			if (action.payload.templateLayout) {
				return { ...state, items: state.items.filter(layout => layout._id !== action.payload._id) };
			}
			return state;
		case RECEIVE_UPDATE_LAYOUT:
			return {
				...state,
				items: state.items.map(layout => (layout._id === action.payload._id ? action.payload : layout)),
			};

		default:
			return state;
	}
};
